import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import "./App.css";
import { useIsDarkMode } from "./hook/setting";
import { darkTheme, lightTheme } from "./lib/theme";
import { BrowserRouter } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const AppProvider: React.FC = () => {
  const { isDarkMode } = useIsDarkMode();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const theme = prefersDarkMode ? darkTheme : lightTheme;

  return (
    <BrowserRouter>
      <Auth0Provider
        domain="login.cloud.queryomega.com"
        clientId="Lg6N9c6nUxk8MZV2Dfr0kzAyGgv9BRRs"
        authorizationParams={{
          redirect_uri: window.location.origin,
        }}
        cacheLocation="localstorage"
      >
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Auth0Provider>
    </BrowserRouter>
  );
};

export default AppProvider;
